<!-- ============================================================== -->
<!-- Main wrapper - style you can find in pages.scss -->
<!-- ============================================================== -->
<!-- <div
  id="main-wrapper"
  [ngClass]="{ 'show-sidebar': showMobileMenu }"
  dir="ltr"
  data-theme="light"
  data-layout="vertical"
  [attr.data-sidebartype]="sidebartype"
  data-sidebar-position="absolute"
  data-header-position="absolute"
  data-boxed-layout="full"
>
<div class="page-wrapper">

  <aside
    class="left-sidebar"
    data-sidebarbg="skin6"
    (mouseover)="Logo()"
    (mouseout)="Logo()"
  >
      <app-sidebar></app-sidebar>
  </aside>
 
<div class="" >
  
      <router-outlet></router-outlet>
  
    </div>
    <app-footer></app-footer>
  
  </div>

</div> -->

<div class="main-wrapper" [ngClass]="{ 'sidebar-collapsed': !isSidebarOpen }">
  <!-- Sidebar -->
  <!-- Sidebar (LEFT) -->
  <app-sidebar
    class="sidebar"
    [collapsed]="!isSidebarOpen"
    (toggleSidebar)="toggleSidebar()"
    [class.collapsed]="!isSidebarOpen"
    *ngIf="isAuthenticated"
  >
  </app-sidebar>

  <div class="content-wrapper" [ngClass]="{ unAuthenticate: !isAuthenticated }">
    <!-- Header -->
    <app-header
      (toggleSidebar)="toggleSidebar()"
      [ngClass]="{ unAuthenticate: !isAuthenticated }"
    ></app-header>

    <!-- Main Content -->
    <div class="page-wrapper" [ngClass]="{ unAuthenticate: !isAuthenticated }">
      <div
        class="support-marquee"
        *ngIf="isAuthenticated"
        role="status"
        aria-label="Support contact"
      >
        <marquee
          #supportMarquee
          behavior="scroll"
          direction="left"
          scrollamount="6"
          (mouseenter)="supportMarquee.stop()"
          (mouseleave)="supportMarquee.start()"
        >
          📞 For any technical support-related queries, please contact ✉️
          kunj.tiwari@atishay.com &nbsp;| ✉️ dev.aditya@atishay.com 📞Mob.
          No.-7973719104. &nbsp;&nbsp;|&nbsp; ✉️ For general queries and other
          correspondence, please contact rcs-hp@nic.in or
          rcsofficeshimla@gmail.com
        </marquee>
      </div>
      <router-outlet></router-outlet>
    </div>
    <!-- Footer -->
    <app-footer [ngClass]="{ unAuthenticate: !isAuthenticated }"></app-footer>
  </div>
</div>
